import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { IUnidadTransporte } from '../models/unidadTransporte';
import { IUnidadDisponible } from '../models/unidaddisponible';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { IResultadoGeneral } from '../models/resultadogeneral';
import { InumEconomico } from '../models/numEconomico';
import { Iaprovechamiento } from '../models/aprovechamiento';
import { ISinServicio } from '../models/sinservicio';
import { IpostguardarUnidadadsinruta } from '../models/postguardarUnidadadsinruta';
import { IRemolque } from '../models/sctRemolques';
import { ITipoPermisoSCT } from '../models/sctTipoPermiso';
import { IConfigAutoTrSCT } from '../models/sctConfigAutoTra';
import { ISubTipoRemolqueSCT } from '../models/sctSubTipoRemolque';
import { ICajasManeged } from '../models/cajasManeged';
import { IAdmnRemolquesUnidad } from '../models/sctAdmRemolquesUnidad';
import { ICriterio } from '../models/criterioasignacion';
import { IConMantenimiento } from '../models/consultaMantenimiento';
import { IPermisoMtto } from '../models/permisoMtto';


@Injectable({
  providedIn: 'root'
})
export class UnidadtransporteService {
  private apiUrl: string = '';
  constructor(private http: HttpClient) {
    this.apiUrl = environment.SUrlgApi + 'Unidad';
  }

  getListadoUnidades() {
    return this.http.get<any>('assets/json/unidadesTransporte.json')
      .toPromise()
      .then(res => <IUnidadTransporte[]>res.data)
      .then(data => { return data; });
  }

  getListadoUnidadesDisponiblesAlDia(num_opcion: number, id_tipo_transporte: number, id_ciudad: number, fecha: string, id_ruta:number): Observable<IUnidadDisponible[]> {
    const valores = {
      params: new HttpParams().
        set('id_tipo_transporte', id_tipo_transporte).
        set('id_ciudad', id_ciudad).
        set('fecha', fecha).
        set('id_ruta', id_ruta)
    };
    return this.http
      .get<IUnidadDisponible[]>(this.apiUrl + '/GetListadoUniDisp/' + num_opcion, valores)
      .pipe(retry(1), catchError(this.handleError));

  }
  getcataprovechamiento():Observable<Iaprovechamiento[]>{
    return this.http
    .get<Iaprovechamiento[]>(this.apiUrl + '/GetTipoAprovechamiento')
    .pipe(retry(1), catchError(this.handleError));
  }

  getserviciossinruta(fecha_fil_sin_reg: string): Observable<ISinServicio[]> {
    const params = new HttpParams().set('fecha_fil_sin_reg', fecha_fil_sin_reg);

    return this.http
      .get<ISinServicio[]>(this.apiUrl + '/Getrutassinservicio', { params })
      .pipe(retry(1), catchError(this.handleError));
  }


  getcriterio(id_ciudad_hm:number, fecha_fil: string): Observable<ICriterio[]> {

    const params = new HttpParams().set('id_ciudad_hm', id_ciudad_hm).set('fecha_fil', fecha_fil);
    return this.http
      .get<ICriterio[]>(this.apiUrl + '/Getcriterio' , { params })
      .pipe(retry(1), catchError(this.handleError));
  }

  rptcriterio(id_ciudad_hm:number, fecha_fil: string): Observable<any> {
    const valores = {
      params: new HttpParams()
        .set('id_ciudad_hm', id_ciudad_hm)
        .set('fecha_fil', fecha_fil)
    };
    return this.http.get<any>(this.apiUrl + '/rptcriterio', valores)
      .pipe(retry(1), catchError(this.handleError));
  }




  getListadoUnidadesDisponiblesAlDia_sinservico(num_opcion: number, id_tipo_transporte: number, id_ciudad: number, fecha: string, id_ruta:number): Observable<IUnidadDisponible[]> {
    const valores = {
      params: new HttpParams().
        set('id_tipo_transporte', id_tipo_transporte).
        set('id_ciudad', id_ciudad).
        set('fecha', fecha).
        set('id_ruta', id_ruta)
    };
    return this.http
      .get<IUnidadDisponible[]>(this.apiUrl + '/GetListadoUniDispsinservico/' + num_opcion, valores)
      .pipe(retry(1), catchError(this.handleError));

  }


  getListadoNumEconomicoSimplified(cod_usuario?:string): Observable<InumEconomico[]> {
    return this.http
      .get<InumEconomico[]>(this.apiUrl+'/getUnidadesSimplified')
      .pipe(retry(1), catchError(this.handleError));
  }

  public guardarUnidadadsinruta(data: IpostguardarUnidadadsinruta):Observable<any>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl + '/postguardarUnidadadsinruta/',body,{'headers':headers});
   }

   public update_sinservicio(data: any):Observable<any>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl + '/updatesinruta/',body,{'headers':headers});
   }


  postGuardarUnidadAlDia(
    num_opcion: number,
    idx_pao_unidades: number,
    idx_pao_diario: number,
    id_ruta: number,
    fecha: string,
    cod_chofer: number,
    id_unidad_transporte: number,
    cod_adicional1: number,
    cod_adicional2: number,
    id_puesto: number,
    id_puesto1: number,
    id_puesto2: number,
    clv_retardo: number,
    clv_retardo1: number,
    clv_retardo2: number,
    cod_usuario: string,
    clv_especial: number,
    clv_apoyo_driver: number,
    clv_confirma_combustible: number,
    clv_confirma_casetas : number,
    id_ruta_travel:  string,
    id_tipo_aprovechamiento:number,
    rostering_id :  string,

):
    Observable<IResultadoGeneral> {
    let cod_usuario_cast: any = cod_usuario == 'undefined' ? '0999' : cod_usuario;
    const headers = new HttpHeaders().append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    const body = {};
    let params = new HttpParams().
      set('idx_pao_unidades', idx_pao_unidades).
      set('idx_pao_diario', idx_pao_diario).
      set('id_ruta', id_ruta).
      set('fecha', fecha).
      set('cod_chofer', cod_chofer).
      set('id_unidad_transporte', id_unidad_transporte)
      .set('cod_usuario', cod_usuario_cast)
      .set('cod_adicional1', cod_adicional1)
      .set('cod_adicional2', cod_adicional2)
      .set('id_puesto', id_puesto)
      .set('id_puesto1', id_puesto1)
      .set('id_puesto2', id_puesto2)
      .set('clv_retardo', clv_retardo)
      .set('clv_retardo1',clv_retardo1)
      .set('clv_retardo2', clv_retardo2)
      .set('clv_especial', clv_especial)
      .set('clv_apoyo_driver', clv_apoyo_driver)
      .set('clv_confirma_combustible',clv_confirma_combustible)
      .set('clv_confirma_casetas',clv_confirma_casetas)
      .set('id_ruta_travel',id_ruta_travel)
      .set('id_tipo_aprovechamiento',id_tipo_aprovechamiento)
      .set('rostering_id',rostering_id)
      ;
    return this.http.post<IResultadoGeneral>(this.apiUrl + '/GetGuardarUniDiario/' + num_opcion, body, {
      headers: headers,
      params: params,
    });
  }
  postGuardarUnidadAlDia_sin_ruta(
    num_opcion: number,
    idx_pao_unidades: number,
    idx_pao_diario: number,
    id_ruta: number,
    fecha: string,
    cod_chofer: number,
    id_unidad_transporte: number,
    cod_adicional1: number,
    cod_adicional2: number,
    id_puesto: number,
    id_puesto1: number,
    id_puesto2: number,
    clv_retardo: number,
    clv_retardo1: number,
    clv_retardo2: number,
    cod_usuario: string,
    clv_especial: number,
    clv_apoyo_driver: number,
    clv_confirma_combustible: number,
    clv_confirma_casetas : number,
    id_ruta_travel:  string,
    id_tipo_aprovechamiento:number,
    id_folio:number,
    rostering_id:string
):
    Observable<IResultadoGeneral> {
    let cod_usuario_cast: any = cod_usuario == 'undefined' ? '0999' : cod_usuario;
    const headers = new HttpHeaders().append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    const body = {};
    let params = new HttpParams().
      set('idx_pao_unidades', idx_pao_unidades).
      set('idx_pao_diario', idx_pao_diario).
      set('id_ruta', id_ruta).
      set('fecha', fecha).
      set('cod_chofer', cod_chofer).
      set('id_unidad_transporte', id_unidad_transporte)
      .set('cod_usuario', cod_usuario_cast)
      .set('cod_adicional1', cod_adicional1)
      .set('cod_adicional2', cod_adicional2)
      .set('id_puesto', id_puesto)
      .set('id_puesto1', id_puesto1)
      .set('id_puesto2', id_puesto2)
      .set('clv_retardo', clv_retardo)
      .set('clv_retardo1',clv_retardo1)
      .set('clv_retardo2', clv_retardo2)
      .set('clv_especial', clv_especial)
      .set('clv_apoyo_driver', clv_apoyo_driver)
      .set('clv_confirma_combustible',clv_confirma_combustible)
      .set('clv_confirma_casetas',clv_confirma_casetas)
      .set('id_ruta_travel',id_ruta_travel)
      .set('id_tipo_aprovechamiento',id_tipo_aprovechamiento)
      .set('id_folio',id_folio)
      .set('rostering_id', rostering_id)
      ;
    return this.http.post<IResultadoGeneral>(this.apiUrl + '/GetGuardarUniDiario_sinfolio/' + num_opcion, body, {
      headers: headers,
      params: params,
    });
  }

  public eliminarmovsin(data: any):Observable<any>{
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl + '/updatesinruta/',body,{'headers':headers});
   }

  //  public finalizaroperacion(data:any, estatus:number):Observable<IResultadoGeneral>{
  //   const headers = { 'content-type': 'application/json'}
  //   const body = JSON.stringify(data);
  //   return this.http.put<any>(this.apiUrl + '/CancelarFinalizarRuta/'+estatus,body,{'headers':headers});
  //  }
  //data.idx_pao_diario,this.user.cod == undefined ? '0999' : this.user.cod, 0,  estatus
  //  finalizaroperacion(idx:number, cod_usuario_finalizo:string, clv_finalizo:number,estatus:number): Observable<any[]> {
  //   const valores = {
  //     params: new HttpParams().

  //       set('idx_pao_diario', idx_pao_diario).
  //       set('cod_usuario_finalizo', cod_usuario_finalizo).
  //       set('clv_finalizo', clv_finalizo)
  //   };
  //   return this.http
  //     .put<any[]>(this.apiUrl + '/CancelarFinalizarRuta/'+estatus, valores)
  //     .pipe(retry(1), catchError(this.handleError));

  // }

  finalizaroperacion(
    num_opcion: number,
    idx: number,
    cod_usuario_finalizo:string,
    clv_finalizo: number,

):
    Observable<IResultadoGeneral> {
      let cod_usuario_cast: string = cod_usuario_finalizo === undefined || cod_usuario_finalizo === 'undefined' ? '0999' : cod_usuario_finalizo;

    const headers = new HttpHeaders().append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    const body = {};
    let params = new HttpParams().
      set('num_opcion', num_opcion).
      set('idx', idx).
      set('cod_usuario_finalizo', cod_usuario_cast).
      set('clv_finalizo', clv_finalizo)

      ;
    return this.http.put<IResultadoGeneral>(this.apiUrl + '/CancelarFinalizarRuta/' + num_opcion, body, {
      headers: headers,
      params: params,
    });
  }
  getListadoTipoPermisoSCT(): Observable<ITipoPermisoSCT[]> {
    return this.http
      .get<ITipoPermisoSCT[]>(this.apiUrl+'/GetPermisosSct')
      .pipe(retry(1), catchError(this.handleError));
  }
  getListadoConfigAutoTraSCT(): Observable<IConfigAutoTrSCT[]> {
    return this.http
      .get<IConfigAutoTrSCT[]>(this.apiUrl+'/GetCfgAutoTrSct')
      .pipe(retry(1), catchError(this.handleError));
  }
  getListadoSubTipoRem(): Observable<ISubTipoRemolqueSCT[]> {
    return this.http
      .get<ISubTipoRemolqueSCT[]>(this.apiUrl+'/GetSubTipoRemSct')
      .pipe(retry(1), catchError(this.handleError));
  }
  getListadoRemolques(): Observable<IRemolque[]> {
    return this.http
      .get<IRemolque[]>(this.apiUrl+'/GetRemolques')
      .pipe(retry(1), catchError(this.handleError));
  }
  getListadoRelRemolques(id_unidad_transporte:number): Observable<ICajasManeged[]> {
    const valores = {
      params: new HttpParams().
        set('id_unidad_transporte', id_unidad_transporte)
    };
    return this.http
      .get<ICajasManeged[]>(this.apiUrl+'/GetRelTransporteRemolques/',valores)
      .pipe(retry(1), catchError(this.handleError));
  }
  admListadoRelRemolques(data: IAdmnRemolquesUnidad): Observable<ICajasManeged[]> {
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl + '/AdminRelTransporteRemolques/',body,{'headers':headers});
  }
  earseRemolque(data: any): Observable<IResultadoGeneral> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let data_enviar={headers:headers, body : data};

    return this.http.delete<IResultadoGeneral>(this.apiUrl +'/DelRemolque', data_enviar)
      .pipe(catchError(this.handleError));
  }
  updateStatusRemolque(data: any): Observable<IResultadoGeneral> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = JSON.stringify(data);

    return this.http.put<IResultadoGeneral>(this.apiUrl +'/UpdateStatus', body,{'headers':headers})
      .pipe(catchError(this.handleError));
  }
  //  public editClienteCompleto(data: ICliente ):Observable<any>{
  //     const headers = { 'content-type': 'application/json'}
  //     const body = JSON.stringify(data);
  //     return this.http.put<any>(this.apiUrl + '/editClienteCompleto/',body,{'headers':headers});
  //    }
  getConsultaMantenimiento(id_ciudad_hm:number): Observable<IConMantenimiento[]> {
    const params = new HttpParams().set('id_ciudad_hm', id_ciudad_hm);
    return this.http
      .get<IConMantenimiento[]>(this.apiUrl + '/GetConsultaMantenimiento' , { params })
      .pipe(retry(1), catchError(this.handleError));
  }

  getrptConsultaMantenimiento(id_ciudad_hm:number): Observable<IConMantenimiento[]> {
    const params = new HttpParams().set('id_ciudad_hm', id_ciudad_hm);
    return this.http
      .get<IConMantenimiento[]>(this.apiUrl + '/GetrptConsultaMantenimiento' , { params })
      .pipe(retry(1), catchError(this.handleError));
  }
  consultaListadoPermisosMtto(id_unidad_transporte: number): Observable<IPermisoMtto[]> {
    const valores = {
      params: new HttpParams().
        set('id_unidad_transporte', id_unidad_transporte)
    };
    return this.http
      .get<IPermisoMtto[]>(this.apiUrl + '/GetPermisosMtto/', valores)
      .pipe(retry(1), catchError(this.handleError));
  }
  earsePermisosMtto(data: any): Observable<IResultadoGeneral> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let data_enviar={headers:headers, body : data};

    return this.http.delete<IResultadoGeneral>(this.apiUrl +'/erasePermisoMtto', data_enviar)
      .pipe(catchError(this.handleError));
  }
  addPermisosMtto(data: any): Observable<IResultadoGeneral> {
    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl + '/savePermisoMtto/',body,{'headers':headers});
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
